module.exports = __webpack_public_path__ + "static/media/sortup-focused.d4114267.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/sortup-focused.svg
// module id = 959
// module chunks = 0